<div *ngFor="let tooltip of tooltips; index as i" [attr.data-test-id]="'tooltip-' + i">
  <b>{{ tooltip.name }}</b
  >: {{ tooltip.value }}
</div>
<div *ngIf="itemsKind" data-test-id="items-kind">
  <b>{{ itemsKind }}</b
  >: {{ itemsCount }}
</div>
